import { apiFetch } from '../../lib/api';

export type BindingStatusValue = 'pending' | 'connected' | 'bound' | 'failed' | 'cancelled';

export interface DeviceBindingCreate {
  binding_id: string;
  owner_token: string;
  server_url: string;
  region?: string;
  expires_in?: number;
}

export interface DeviceBindingStatus {
  binding_id?: string;
  status: BindingStatusValue;
  device_id?: string;
  reason?: string;
}

export async function createDeviceBinding(): Promise<DeviceBindingCreate> {
  const res = await apiFetch<DeviceBindingCreate>('/v3/devices/binding', { method: 'POST', body: {} });
  return res.data;
}

export async function getDeviceBindingStatus(bindingId: string): Promise<DeviceBindingStatus> {
  const res = await apiFetch<DeviceBindingStatus>(`/v3/devices/binding/${encodeURIComponent(bindingId)}`);
  return res.data;
}

export async function cancelDeviceBinding(bindingId: string): Promise<void> {
  await apiFetch(`/v3/devices/binding/${encodeURIComponent(bindingId)}`, { method: 'DELETE' });
}
